import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

export const useThemes = () => {
  return useQuery({
    queryKey: QUERY_KEYS.themes,
    queryFn: () => container.themes.list(),
    staleTime: 10 * 60 * 1000,
  });
};
